var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-link-container"},[_c('button',{staticClass:"help-link",attrs:{"type":"button","title":"Need Help? Contact Us.","aria-label":"Need Help? Contact Us."},on:{"click":function($event){return _vm.$emit('contact')}}},[_vm._v(" Need Help? Contact Us. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }